/**
 * A „MI EZ?" VÁLASZTÁSAI — egy helyen, mert három felület kínálja őket (#85):
 * a lista utólagos választója (`DocTypePicker`), a mobil feltöltő-lap
 * (`UploadSheet`) és az asztali köteg-panel (`BatchPanel`).
 *
 * A SORREND A FELÜLETÉ, a halmaz a szerveré: a `CLIENT_DECLARABLE_DOC_TYPES`
 * és a cég engedélye (#25/3) dönti el, mi választható. Itt csak az áll, hogy
 * a felkínáltak milyen sorrendben, milyen felirattal jelennek meg.
 *
 * A „NEM TUDOM" NINCS A LISTÁBAN, és ez szándékos: az nem típus, hanem a
 * típus hiánya — a `clientDocType` `NULL` marad. Minden felület külön,
 * egyenrangú menekülőútként rajzolja.
 */

import type { ClientDocType } from './types';

type Translate = (key: string) => string;

export const DOC_TYPE_CHOICES: readonly ClientDocType[] = [
  'INBOUND_INVOICE',
  'OUTBOUND_INVOICE',
  'RECEIPT',
  'OTHER',
];

/**
 * A felkínálható típusok, a cég engedélyére szűkítve. `null` = a szerver nem
 * mondta meg (régebbi válasz) — ilyenkor mind felkínálva, és a tiltottat a
 * szerver utasítja el.
 */
export function offeredDocTypes(allowed: readonly ClientDocType[] | null): ClientDocType[] {
  return DOC_TYPE_CHOICES.filter((docType) => allowed === null || allowed.includes(docType));
}

/** A rendes megnevezés — „Bejövő számla". Kulcsonként kiírva, hogy a fordítás-fedés lássa. */
export function docTypeLabel(t: Translate, docType: ClientDocType): string {
  switch (docType) {
    case 'INBOUND_INVOICE':
      return t('docType.INBOUND_INVOICE');
    case 'OUTBOUND_INVOICE':
      return t('docType.OUTBOUND_INVOICE');
    case 'RECEIPT':
      return t('docType.RECEIPT');
    default:
      return t('docType.OTHER');
  }
}

/** A könnyebb szó alatta — „Számla egy cégtől" *(Viktor, 2026-09-13)*. */
export function docTypeHint(t: Translate, docType: ClientDocType): string {
  switch (docType) {
    case 'INBOUND_INVOICE':
      return t('docType.hint.INBOUND_INVOICE');
    case 'OUTBOUND_INVOICE':
      return t('docType.hint.OUTBOUND_INVOICE');
    case 'RECEIPT':
      return t('docType.hint.RECEIPT');
    default:
      return t('docType.hint.OTHER');
  }
}
